import { LiveAnnouncer } from '@angular/cdk/a11y';
import { DatePipe, DecimalPipe, NgClass } from '@angular/common';
import { Component, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort, MatSortHeader } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow } from '@angular/material/table';
import { Router } from '@angular/router';
import { BudgetListModel } from 'src/app/models/budget-list.model';
import { ScheduleDatesFilterModel } from 'src/app/models/filter-date.model';
import { BudgetService } from 'src/app/services/budget.service';
import { ToastService } from 'src/app/services/toast.service';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { MatIcon } from '@angular/material/icon';
import { DatesFilterComponent } from '../../dates-filter/dates-filter.component';

import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';

@Component({
    selector: 'app-budget-list',
    templateUrl: './budget-list.component.html',
    styleUrls: ['./budget-list.component.scss'],
    imports: [MatIcon, DatesFilterComponent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, NgClass, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow, MatPaginator, DatePipe, DecimalPipe, PageHeaderComponent, EmptyStateComponent]
})
export class BudgetListComponent {
  private readonly budgesvc = inject(BudgetService);
  private readonly paginatorService = inject(CommonFunctionsConfiguratorService);
  private readonly _liveAnnouncer = inject(LiveAnnouncer);
  private readonly router = inject(Router);
  toastr = inject(ToastService);
  datepipe = inject(DatePipe);


  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: string[] = [
    'budgetDate',
    'clientName',
    'poolModel',
    'cashPrice',
    'isFinished',
    'print',
  ];

  budgets: BudgetListModel[] = [];

  dataSource = new MatTableDataSource<BudgetListModel>();
  filteringDate!: ScheduleDatesFilterModel;
  isVisible: boolean = false;

  ngOnInit() {
    this.getBudgets();
  }

  onSubmit(dates?: ScheduleDatesFilterModel) {
    if (dates != undefined) {
      this.budgesvc.getAllBudget(dates.from, dates.to).subscribe((data) => {
        this.budgets = data;
        this.dataSource = new MatTableDataSource(this.budgets);
        this.paginatorService.configurePaginator(
          this.dataSource,
          this.paginator,
          this.sort,
          "Presupuestos"
        );
        this.toggleVisibility();
      });
    } else {
      this.budgesvc.getAllBudget().subscribe((data) => {
        this.budgets = data;
        this.dataSource = new MatTableDataSource(this.budgets);
        this.paginatorService.configurePaginator(
          this.dataSource,
          this.paginator,
          this.sort,
          "Presupuestos"
        );
        this.toggleVisibility();
      });
    }
  }

  getBudgets() {
    this.budgesvc.getAllBudget().subscribe((data) => {
      this.budgets = data;
      this.dataSource = new MatTableDataSource(this.budgets);
      this.paginatorService.configurePaginator(
        this.dataSource,
        this.paginator,
        this.sort,
        "Presupuestos"
      );
    });
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  goBudgetDetail(id: string, isCompleted: boolean) {
    this.router.navigate(['/budget'], { queryParams: { id: id, isCompleted } });
  }

  setDates(dates: ScheduleDatesFilterModel) {
    if (dates.from == '' && dates.to == '') {
      this.getBudgets();
      this.toggleVisibility();
    } else {
      this.filteringDate = dates;
      this.onSubmit(this.filteringDate);
    }
  }

  closeModal() {
    this.isVisible = false;
  }

  toggleVisibility() {
    this.isVisible = !this.isVisible;
  }
}
